module.exports = __webpack_public_path__ + "static/media/why_carwiser_banner_desktop.7f39e78a.png";